import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion as MuiAccordion,
  type AccordionProps,
  AccordionDetails,
  AccordionSummary,
  styled,
} from "@mui/material";
import { rem } from "polished";
import React from "react";

const StyledAccordionSummary = styled(AccordionSummary)`
  background-color: ${(props) => props.theme.palette.primary.main};
  font-size: ${rem(16)};
  font-weight: bold;
  color: ${(props) => props.theme.palette.primary.contrastText};
  svg {
    fill: ${(props) => props.theme.palette.primary.contrastText};
  }
`;

const StyledAccordionDetails = styled(AccordionDetails)`
  background-color: ${(props) => props.theme.palette.primary.light};
  padding: ${(props) => props.theme.spacing(4)};
`;

const StyledAccordionTitle = styled("h4")`
  margin: 0;
`;

interface Props extends AccordionProps {
  title: string;
}

export const Accordion = ({ title, children, ...accordionProps }: Props) => {
  return (
    <MuiAccordion {...accordionProps}>
      <StyledAccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content">
        <StyledAccordionTitle>{title}</StyledAccordionTitle>
      </StyledAccordionSummary>
      <StyledAccordionDetails>{children}</StyledAccordionDetails>
    </MuiAccordion>
  );
};
